<template>
  <div class="tab-container">
    <div
      class="tab"
      v-for="(route, index) in historyRouteList"
      :key="index"
      :class="
        $route.fullPath === route.fullPath
          ? 'active'
          : $route.name === route.name && !$route.fullPath
          ? 'active'
          : ''
      "
    >
      <a-tooltip placement="top">
        <template slot="title">
          {{ route.type ? route.title : $t(route.title || route?.meta?.title) }}
        </template>
        <router-link
          :to="route.fullPath"
          :title="route.type ? route.title : $t(route.title || route?.meta?.title)"
          class="tab-link"
        >
          {{ route.type ? route.title : $t(route.title || route?.meta?.title) }}
        </router-link>
      </a-tooltip>
      <!-- Home页面不允许删除，当前页面不允许删除 -->
      <p
        @click="deleteRoute(route)"
        v-if="route.name !== 'Home'"
        :title="route.type ? route.title : $t(route.title || route?.meta?.title)"
      >
        <Icon type="cancel" />
      </p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['historyRouteList']),
  },
  watch: {
    historyRouteList() {
      this.$nextTick(() => {
        this.calculateWidth();
      });
    },
  },
  methods: {
    deleteRoute(route) {
      this.$store.commit('removeHistoryRouteList', route);

      this.calculateWidth();
      return false;
    },

    // 计算 Tabs 宽度
    calculateWidth() {
      const tabContainer = document.querySelector('.tab-container');
      const tabs = document.querySelectorAll('.tab');

      const parentWidth = tabContainer.clientWidth; // 父容器的宽度

      let totalTabWidth = 0;
      // 重置每个 Tab 的宽度
      tabs.forEach(tab => {
        tab.style.width = 'auto';
        tab.style.overflow = 'auto';
        tab.style.textOverflow = 'auto';
      });

      // 计算每个 Tab 的实际内容宽度
      tabs.forEach(tab => {
        const span = document.createElement('span');
        span.style.visibility = 'hidden';
        span.style.whiteSpace = 'nowrap';
        span.textContent = tab.querySelector('.tab-link').textContent;
        // console.log('textContent', span.textContent);
        document.body.appendChild(span);
        const tabWidth = span.offsetWidth; // 包括内边距
        document.body.removeChild(span);
        // console.log('tabWidth', tabWidth);

        tab.style.width = `${tabWidth}px`;
        totalTabWidth += tabWidth;
      });

      // 检查总宽度是否超出父容器宽度
      if (totalTabWidth > parentWidth) {
        // 超过父容器宽度，按比例缩小每个 Tab 的宽度，并添加省略号
        const scaleFactor = parentWidth / totalTabWidth;
        tabs.forEach(tab => {
          const originalWidth = parseInt(tab.style.width, 10);
          const adjustedWidth = Math.floor(originalWidth * scaleFactor);
          tab.style.width = `${adjustedWidth}px`;
          tab.style.textOverflow = 'ellipsis'; // 添加省略号
          tab.style.overflow = 'hidden'; // 隐藏溢出内容
        });

        tabContainer.style.justifyContent = 'space-between'; // Tabs 撑满容器
      } else {
        // 总宽度小于父容器宽度时，保持原始宽度，不使用省略号，靠左对齐
        tabContainer.style.justifyContent = 'flex-start';
        tabs.forEach(tab => {
          tab.style.width = 'auto';
          tab.style.textOverflow = 'clip'; // 不使用省略号
          tab.style.overflow = 'visible'; // 允许内容完全显示
          tab.style.padding = '0 10px';
        });
      }
    },
  },
  mounted() {
    this.calculateWidth();
    window.addEventListener('resize', this.calculateWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateWidth);
  },
};
</script>
<style lang="less" scoped>
.tab-container {
  display: flex;
  box-sizing: border-box;
  justify-content: flex-start; /* 初始时 Tabs 靠左对齐 */
  overflow-x: hidden; /* 防止溢出时出现滚动条 */
  height: 40px; /* 确保容器高度为 40px */
  align-items: center;

  .tab {
    display: flex; /* 子元素水平排列 */
    align-items: center; /* 垂直居中 */
    padding: 5px 5px 5px 10px;
    box-sizing: border-box;
    white-space: nowrap; /* 不换行 */
    overflow: hidden;
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    margin-right: 8px; /* Tabs 之间的间距 */
    border-radius: 8px; /* 圆角 */
    height: 100%; /* 使每个 Tab 占满容器高度 */
    background-color: #fff;
    justify-content: space-between;
    min-width: 65px;

    &:first-child {
      min-width: 60px;
    }

    &:last-child {
      margin-right: 0;
    }

    &.active {
      a {
        color: @primary-color;
      }
    }

    a {
      color: black;
      font-size: 14px; /* 字体大小 16px */
      text-decoration: none; /* 移除下划线 */
      border-radius: 8px; /* 圆角 */
      display: block;
      white-space: nowrap; /* 不换行 */
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis; /* 超出部分显示省略号 */
      flex: 1;

      &:hover {
        cursor: pointer;
        color: @primary-color;
      }
    }

    p {
      margin: 0;
      font-size: 14px; /* 描述文字稍小 */
      color: #666;
      white-space: nowrap; /* 不换行 */
      overflow: hidden;
      text-overflow: ellipsis; /* 超出部分显示省略号 */
      min-width: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        color: @primary-color;
      }
    }
  }
}
</style>
